import type { Connection } from '@blocksuite/affine-model';

export class ConnectorReconnectSession {
  private _finished = false;

  private _pending: Connection;

  readonly original: Connection;

  constructor(original: Connection) {
    this.original = structuredClone(original);
    this._pending = structuredClone(original);
  }

  get activeTargetId() {
    return this._pending.id;
  }

  get pending() {
    return structuredClone(this._pending);
  }

  update(next: Connection) {
    if (this._finished) return false;
    this._pending = structuredClone(next);
    return true;
  }

  commit(captureSync: () => void, write: (value: Connection) => void) {
    if (this._finished) return false;
    this._finished = true;
    captureSync();
    write(this.pending);
    captureSync();
    return true;
  }

  cancel() {
    if (this._finished) return false;
    this._finished = true;
    return true;
  }
}
